const o = (n, i) => n === i ? I18n.t("booking_engine.payment.payment_details") : n === i - 1 ? I18n.t("online_check_in.your_booking_details") : I18n.t("booking_engine.information.customise_booking");
export {
  o as getTitle
};
